
function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }


var FacebookLogin = require('react-facebook-login');


var React = require('react');
var React__default = _interopDefault(React);

var labels = {
  loginTitle: "Log in",
  signupTitle: "Create new user",
  forgotHeader: "Reset password",
  loginFacebookButton: "Log in with Facebook",
  loginGoogleButton: "Log in with Google",
  loginEmailButton: "Log in with email",
  signupFacebookButton: "Sign up with Facebook",
  signupGoogleButton: "Sign up with Google",
  signupEmailButton: "Sign up with email",
  forgotButton: "Send new password",
  loginEmailPlaceholder: "Type email",
  loginPasswordPlaceholder: "Type password",
  signupUsernamePlaceholder: "Type username",
  signupLink: "Create new user?",
  loginLink: "Already a user?",
  forgotLink: "Forgot password?",
  orLabel: "or"
};

var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var usernameRegex = /^[a-zA-Z0-9_-]{5,}/;
var passwordRegex = /^[a-zA-Z0-9_@!#()]{8,}/;

var focusStyle = function focusStyle(focus) {
  return focus ? { backgroundColor: "#fff" } : { backgroundColor: "#e6e7f2" };
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".login-modal_bgMatte__1EaWk {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: fixed;\r\n  background-color: #444;\r\n  z-index: 100;\r\n  opacity: 0.7; \r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.login-modal_center__1bGfh {\r\n  margin: 0 auto 0 auto; }\r\n\r\n.login-modal_logInHolder__3fA0H {\r\n  width: 90%;\r\n  background-color: #f8f8f8;\r\n  box-shadow: 0 2px 8px #222;\r\n  font-family: 'Open Sans', sans-serif;\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 200;\r\n  overflow: hidden;\r\n  padding-left: 40px;\r\n  padding-right: 40px; }\r\n  @media (min-width: 768px) {\r\n    .login-modal_logInHolder__3fA0H {\r\n      width: 500px;\r\n      margin: 0; } }\r\n\r\n.login-modal_logInHolder__3fA0H a {\r\n  text-decoration: none;\r\n  color: #000; }\r\n  .login-modal_logInHolder__3fA0H a:hover {\r\n    color: #000; }\r\n\r\n.login-modal_floatRight__3jzSl {\r\n  float: right; }\r\n\r\n.login-modal_floatLeft__3dC7q {\r\n  float: left; }\r\n\r\n.login-modal_logInHolder__3fA0H h1 {\r\n  font-size: 20px;\r\n  color: #444;\r\n  text-align: left; }\r\n\r\n.login-modal_logInTopRow__Y5nqA {\r\n  width: 100%;\r\n  height: 30px;\r\n  margin-top: 5px; }\r\n\r\n.login-modal_logInCloseBtn__ksShG {\r\n  cursor: pointer;\r\n  color: #999;\r\n  transition: opacity 0.3s;\r\n  margin-right: -35px; }\r\n\r\n.login-modal_logInCloseBtnHover__3lAkg {\r\n  opacity: 0.8; }\r\n\r\n.login-modal_loginForm__3crM_ {\r\n  width: 100%; }\r\n\r\n.login-modal_submitForm__2oh7q {\r\n  width: 100%; }\r\n\r\n.login-modal_forgotForm__2OMOy {\r\n  width: 100%; }\r\n\r\n.login-modal_loginBtn__3dfDV {\r\n  width: 100%;\r\n  height: 50px;\r\n  margin-top: 20px;\r\n  border-radius: 5px;\r\n  line-height: 50px;\r\n  text-align: center;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 4px #666;\r\n  opacity: 1;\r\n  transition: all 0.3s;\r\n  font-weight: bold; }\r\n  .login-modal_loginBtn__3dfDV:hover {\r\n    box-shadow: 0 4px 6px #666;\r\n    opacity: 0.9; }\r\n\r\n.login-modal_disabled__3PX4N {\r\n  cursor: default;\r\n  opacity: 0.7; }\r\n  .login-modal_disabled__3PX4N:hover {\r\n    box-shadow: 0 2px 4px #666;\r\n    opacity: 0.7; }\r\n\r\n.login-modal_facebookBtnLogo__2FHsa {\r\n  width: 50px;\r\n  height: 50px;\r\n  background-image: url(../graphics/facebook-icon.svg);\r\n  background-size: 50%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  border-radius: 5px 0 0 5px;\r\n  float: left; }\r\n\r\n.login-modal_googleBtnLogo__2sNAi {\r\n  width: 50px;\r\n  height: 50px;\r\n  background-image: url(../graphics/gplus-icon.svg);\r\n  background-size: 50%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  border-radius: 5px 0 0 5px;\r\n  float: left; }\r\n\r\n.login-modal_emailBtnLogo__fij7E {\r\n  width: 50px;\r\n  height: 50px;\r\n  background-size: 50%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  border-radius: 5px 0 0 5px;\r\n  float: left;\r\n  text-align: center; }\r\n\r\n.login-modal_emailLogo__2ulIB {\r\n  color: #E2DBE2;\r\n  font-size: 30px;\r\n  transform: rotate(90deg);\r\n  line-height: 50px; }\r\n\r\n.login-modal_lineTextHolder__2Jj7U {\r\n  width: 100%;\r\n  height: 20px;\r\n  margin-top: 30px; }\r\n\r\n.login-modal_lineTextLine__1pyI2 {\r\n  width: 100%;\r\n  height: 11px;\r\n  border-bottom: 1px solid #a0a0a0; }\r\n\r\n.login-modal_lineTextText__3Myve {\r\n  width: 60px;\r\n  height: 20px;\r\n  background-color: #f8f8f8;\r\n  color: #a0a0a0;\r\n  line-height: 20px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  margin-top: -10px; }\r\n\r\n.login-modal_loginInput__2eFnd {\r\n  width: 100%;\r\n  height: 40px;\r\n  background-color: #e6e7f2;\r\n  border-top: 1px solid #afb6bc;\r\n  border-left: 1px solid #d4d8db;\r\n  border-right: 1px solid #d4d8db;\r\n  border-bottom: 1px solid #d4d8db;\r\n  color: #474747;\r\n  font-size: 13px;\r\n  padding: 10px;\r\n  outline: none;\r\n  margin-top: 10px; }\r\n\r\n.login-modal_loginLinksHolder__2USDF {\r\n  width: 100%;\r\n  height: 20px; }\r\n\r\n.login-modal_loginLinks__CblDI {\r\n  margin-top: 10px;\r\n  margin-bottom: 20px;\r\n  margin-right: 10px;\r\n  text-decoration: underline;\r\n  float: left;\r\n  cursor: pointer;\r\n  transition: color 0.3s;\r\n  font-size: 14px; }\r\n\r\n.login-modal_facebookBtnBg__ecXHz {\r\n  background-color: #4299E6; }\r\n\r\n.login-modal_facebookBtnLogoBg__2be3J {\r\n  background-color: #3B89CF; }\r\n\r\n.login-modal_googleBtnBg__qz2el {\r\n  background-color: #DB4437; }\r\n\r\n.login-modal_googleBtnLogoBg__1vXsk {\r\n  background-color: #c93c32; }\r\n\r\n.login-modal_emailBtnBg__2a6gT {\r\n  background-color: #6B6861; }\r\n\r\n.login-modal_emailBtnLogoBg__1fpAD {\r\n  background-color: #484642; }\r\n\r\n.login-modal_loginLinksCol__2IUll {\r\n  color: #1e76c9; }\r\n\r\n.login-modal_loginLinksCol__2IUll:hover {\r\n  color: #4ab268; }\r\n";
var styles = { "bgMatte": "login-modal_bgMatte__1EaWk", "center": "login-modal_center__1bGfh", "logInHolder": "login-modal_logInHolder__3fA0H", "floatRight": "login-modal_floatRight__3jzSl", "floatLeft": "login-modal_floatLeft__3dC7q", "logInTopRow": "login-modal_logInTopRow__Y5nqA", "logInCloseBtn": "login-modal_logInCloseBtn__ksShG", "logInCloseBtnHover": "login-modal_logInCloseBtnHover__3lAkg", "loginForm": "login-modal_loginForm__3crM_", "submitForm": "login-modal_submitForm__2oh7q", "forgotForm": "login-modal_forgotForm__2OMOy", "loginBtn": "login-modal_loginBtn__3dfDV", "disabled": "login-modal_disabled__3PX4N", "facebookBtnLogo": "login-modal_facebookBtnLogo__2FHsa", "googleBtnLogo": "login-modal_googleBtnLogo__2sNAi", "emailBtnLogo": "login-modal_emailBtnLogo__fij7E", "emailLogo": "login-modal_emailLogo__2ulIB", "lineTextHolder": "login-modal_lineTextHolder__2Jj7U", "lineTextLine": "login-modal_lineTextLine__1pyI2", "lineTextText": "login-modal_lineTextText__3Myve", "loginInput": "login-modal_loginInput__2eFnd", "loginLinksHolder": "login-modal_loginLinksHolder__2USDF", "loginLinks": "login-modal_loginLinks__CblDI", "facebookBtnBg": "login-modal_facebookBtnBg__ecXHz", "facebookBtnLogoBg": "login-modal_facebookBtnLogoBg__2be3J", "googleBtnBg": "login-modal_googleBtnBg__qz2el", "googleBtnLogoBg": "login-modal_googleBtnLogoBg__1vXsk", "emailBtnBg": "login-modal_emailBtnBg__2a6gT", "emailBtnLogoBg": "login-modal_emailBtnLogoBg__1fpAD", "loginLinksCol": "login-modal_loginLinksCol__2IUll" };
styleInject(css);

var facebookIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22iso-8859-1%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Capa_1%22%20x%3D%220px%22%20y%3D%220px%22%20width%3D%22512px%22%20height%3D%22512px%22%20viewBox%3D%220%200%20430.113%20430.114%22%20style%3D%22enable-background%3Anew%200%200%20430.113%20430.114%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20id%3D%22Facebook%22%20d%3D%22M158.081%2C83.3c0%2C10.839%2C0%2C59.218%2C0%2C59.218h-43.385v72.412h43.385v215.183h89.122V214.936h59.805%20%20%20c0%2C0%2C5.601-34.721%2C8.316-72.685c-7.784%2C0-67.784%2C0-67.784%2C0s0-42.127%2C0-49.511c0-7.4%2C9.717-17.354%2C19.321-17.354%20%20%20c9.586%2C0%2C29.818%2C0%2C48.557%2C0c0-9.859%2C0-43.924%2C0-75.385c-25.016%2C0-53.476%2C0-66.021%2C0C155.878-0.004%2C158.081%2C72.48%2C158.081%2C83.3z%22%20fill%3D%22%23E3DCE3%22%2F%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var googleIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22iso-8859-1%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Capa_1%22%20x%3D%220px%22%20y%3D%220px%22%20width%3D%22512px%22%20height%3D%22512px%22%20viewBox%3D%220%200%2090%2090%22%20style%3D%22enable-background%3Anew%200%200%2090%2090%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20id%3D%22Google%22%20d%3D%22M74.499%2C0H50.144c-6.382%2C0-14.421%2C0.942-21.158%2C6.49c-5.09%2C4.374-7.566%2C10.392-7.566%2C15.828%20%20%20c0%2C9.211%2C7.094%2C18.546%2C19.625%2C18.546c1.182%2C0%2C2.477-0.12%2C3.787-0.235c-0.592%2C1.413-1.189%2C2.594-1.189%2C4.605%20%20%20c0%2C3.662%2C1.893%2C5.902%2C3.547%2C8.029c-5.314%2C0.353-15.249%2C0.942-22.583%2C5.428c-6.975%2C4.143-9.107%2C10.16-9.107%2C14.414%20%20%20C15.499%2C81.846%2C23.778%2C90%2C40.923%2C90c20.336%2C0%2C31.098-11.22%2C31.098-22.33c0-8.143-4.729-12.164-9.932-16.534l-4.258-3.305%20%20%20c-1.295-1.065-3.068-2.479-3.068-5.08c0-2.597%2C1.773-4.254%2C3.307-5.789c4.964-3.896%2C9.933-8.03%2C9.933-16.77%20%20%20c0-8.979-5.68-13.704-8.396-15.947h7.334L74.499%2C0z%20M64.103%2C72.279c0%2C7.322-6.033%2C12.753-17.385%2C12.753%20%20%20c-12.648%2C0-20.809-6.024-20.809-14.405c0-8.393%2C7.568-11.218%2C10.166-12.164c4.969-1.656%2C11.352-1.891%2C12.414-1.891%20%20%20c1.184%2C0%2C1.775%2C0%2C2.725%2C0.115C60.202%2C63.064%2C64.103%2C66.257%2C64.103%2C72.279z%20M54.642%2C34.249c-1.893%2C1.886-5.088%2C3.305-8.045%2C3.305%20%20%20c-10.164%2C0-14.772-13.113-14.772-21.023c0-3.072%2C0.592-6.258%2C2.598-8.74c1.893-2.362%2C5.201-3.899%2C8.277-3.899%20%20%20c9.812%2C0%2C14.899%2C13.229%2C14.899%2C21.73C57.599%2C27.752%2C57.358%2C31.528%2C54.642%2C34.249z%22%20fill%3D%22%23E3DCE3%22%2F%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var LoginForm = function (_Component) {
  inherits(LoginForm, _Component);

  function LoginForm() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, LoginForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      email: "",
      password: "",
      emailFocused: false,
      passwordFocused: false
    }, _this.onEmailInputChange = function (e) {
      _this.setState({ email: e.target.value });
    }, _this.onPasswordInputChange = function (e) {
      _this.setState({ password: e.target.value });
    }, _this.onEmailFocus = function (focus) {
      return function () {
        _this.setState({ emailFocused: focus });
      };
    }, _this.onPasswordFocus = function (focus) {
      return function () {
        _this.setState({ passwordFocused: focus });
      };
    }, _this.inputValidation = function () {
      var emailRegex$$1 = new RegExp(_this.props.emailRegex);
      var passwordRegex$$1 = new RegExp(_this.props.passwordRegex);
      return emailRegex$$1.test(_this.state.email) && passwordRegex$$1.test(_this.state.password);
    }, _this.onLoginFacebook = function () {
      if (_this.props.onLoginFacebook === undefined) console.warn("No function found: Pass a function as props; onLoginFacebook");else _this.props.onLoginFacebook();
    }, _this.onLoginGoogle = function () {
      if (_this.props.onLoginGoogle === undefined) console.warn("No function found: Pass a function as props; onLoginGoogle");else _this.props.onLoginGoogle();
    }, _this.onLoginEmail = function () {
      if (!_this.inputValidation()) return;
      if (_this.props.onLoginEmail === undefined) console.warn("No function found: Pass a function as props; onLoginEmail");else _this.props.onLoginEmail(_this.state.email, _this.state.password);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(LoginForm, [{
    key: "render",
    value: function render() {
      var emailFocusStyle = focusStyle(this.state.emailFocused);
      var passwordFocusStyle = focusStyle(this.state.passwordFocused);
      var buttonDisabled = this.inputValidation() ? "" : styles.disabled;

      var facebookIconStyle = { backgroundImage: "url(" + facebookIcon };
      var googleIconStyle = { backgroundImage: "url(" + googleIcon + ")" };

      return React__default.createElement(
        "div",
        { className: styles.loginForm },
        React__default.createElement(
          "h1",
          null,
          this.props.labels.loginTitle
        ),
        React__default.createElement(
          "div",
          {
            className: [styles.loginBtn, styles.facebookBtnBg].join(" "),
            onClick: this.onLoginFacebook
          },
          React__default.createElement("div", {
            className: [styles.facebookBtnLogo, styles.facebookBtnLogoBg].join(" "),
            style: facebookIconStyle
          }),
          this.props.labels.loginFacebookButton
        ),
 

        React__default.createElement(
          "div",
          {
            className: [styles.loginBtn, styles.googleBtnBg].join(" "),
            onClick: this.onLoginGoogle
          },
          React__default.createElement("div", {
            className: [styles.googleBtnLogo, styles.googleBtnLogoBg].join(" "),
            style: googleIconStyle
          }),
          this.props.labels.loginGoogleButton
        ),
        React__default.createElement(
          "div",
          { className: styles.lineTextHolder },
          React__default.createElement("div", { className: styles.lineTextLine }),
          React__default.createElement(
            "div",
            { className: [styles.lineTextText, styles.center].join(" ") },
            this.props.labels.orLabel
          )
        ),
        React__default.createElement("input", {
          type: "text",
          style: emailFocusStyle,
          placeholder: this.props.labels.loginEmailPlaceholder,
          className: styles.loginInput,
          onChange: this.onEmailInputChange,
          value: this.state.email,
          onFocus: this.onEmailFocus(true),
          onBlur: this.onEmailFocus(false)
        }),
        React__default.createElement("input", {
          type: "password",
          style: passwordFocusStyle,
          placeholder: this.props.labels.loginPasswordPlaceholder,
          className: styles.loginInput,
          onChange: this.onPasswordInputChange,
          value: this.state.password,
          onFocus: this.onPasswordFocus(true),
          onBlur: this.onPasswordFocus(false)
        }),
        React__default.createElement(
          "div",
          {
            className: [styles.loginBtn, styles.emailBtnBg, buttonDisabled].join(" "),
            onClick: this.onLoginEmail
          },
          React__default.createElement(
            "div",
            {
              className: [styles.emailBtnLogo, styles.emailBtnLogoBg].join(" ")
            },
            React__default.createElement(
              "i",
              { className: ["material-icons", styles.emailLogo].join(" ") },
              "open_in_browser"
            )
          ),
          this.props.labels.loginEmailButton
        )
      );
    }
  }]);
  return LoginForm;
}(React.Component);

var LoginModal = function (_Component) {
  inherits(LoginModal, _Component);

  function LoginModal() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, LoginModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = LoginModal.__proto__ || Object.getPrototypeOf(LoginModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      subpageShown: 0
    }, _this.switchSubpage = function (to) {
      return function (e) {
        _this.setState({ subpageShown: to });
      };
    }, _this.modalLabels = function () {
      return _this.props.labels !== undefined ? _this.props.labels : labels;
    }, _this.emailRegex = function () {
      return _this.props.emailRegex !== undefined ? _this.props.emailRegex : emailRegex;
    }, _this.usernameRegex = function () {
      return _this.props.usernameRegex !== undefined ? _this.props.usernameRegex : usernameRegex;
    }, _this.passwordRegex = function () {
      return _this.props.passwordRegex !== undefined ? _this.props.passwordRegex : passwordRegex;
    }, _this.closeModal = function () {
      if (_this.props.toggleModal === undefined) console.log("toggleModal function not found");else _this.props.toggleModal();
    }, _this.bottomLinks = function () {
      var links = [];
      if (_this.state.subpageShown !== 0) links.push(React__default.createElement(
        'div',
        {
          key: 0,
          className: [styles.loginLinks, styles.loginLinksCol].join(' '),
          onClick: _this.switchSubpage(0)
        },
        _this.modalLabels().loginLink
      ));
      if (_this.state.subpageShown !== 1) links.push(React__default.createElement(
        'div',
        {
          key: 1,
          className: [styles.loginLinks, styles.loginLinksCol].join(' '),
          onClick: _this.switchSubpage(1)
        },
        _this.modalLabels().signupLink
      ));
      if (_this.state.subpageShown !== 2) links.push(React__default.createElement(
        'div',
        {
          key: 2,
          className: [styles.loginLinks, styles.loginLinksCol].join(' '),
          onClick: _this.switchSubpage(2)
        },
        _this.modalLabels().forgotLink
      ));
      return links;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(LoginModal, [{
    key: 'render',
    value: function render() {
      if (!this.props.showModal) return false;

      var loginForms = [React__default.createElement(LoginForm, {
        labels: this.modalLabels(),
        emailRegex: this.emailRegex(),
        passwordRegex: this.passwordRegex(),
        onLoginFacebook: this.props.onLoginFacebook,
        onLoginGoogle: this.props.onLoginGoogle,
        onLoginEmail: this.props.onLoginEmail
      })];

      return React__default.createElement(
        'div',
        null,
        React__default.createElement('div', { className: styles.bgMatte, onClick: this.closeModal }),
        React__default.createElement(
          'div',
          { className: styles.logInHolder },
          React__default.createElement(
            'div',
            { className: [styles.logInTopRow, styles.center].join(' ') },
            React__default.createElement(
              'i',
              { className: ["material-icons", styles.floatRight, styles.logInCloseBtn].join(' '), onClick: this.closeModal },
              'close'
            )
          ),
          loginForms[this.state.subpageShown],
        
          React__default.createElement(
            'div',
            { className: styles.loginLinksHolder },
            this.bottomLinks()
          )
        )
      );
    }
  }]);
  return LoginModal;
}(React.Component);

module.exports = LoginModal;
